import { DateTime } from 'luxon';

/** e.g: 08 March 1989 */
export function formatDate(value: DateTime): string {
    if (!value) return '';

    return value.toFormat('dd LLLL yyyy');
}
